import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl,FormGroupDirective } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { NotificationServices } from '../../../../appauth/notification/notificatio.services';
import { CustomValidators } from 'ng2-validation';
import { Valoraciones } from '../../modelo-valoracione/valoraciones.model';
import { ValoracionesServices } from '../../modelo-valoracione/servicios-valoraciones.services';
import { Asignaciones } from '../../../reparar-asignaciones/modelo-asignacione/asignaciones.model';
import { AsignacionesServices } from '../../../reparar-asignaciones/modelo-asignacione/servicios-asignaciones.services';
import { Repuestoservicios } from '../../../reparar-repuestoservicios/modelo-repuestoservicio/repuestoservicios.model';
import { RepuestoserviciosServices } from '../../../reparar-repuestoservicios/modelo-repuestoservicio/servicios-repuestoservicios.services';

@Component({
	selector: 'app-insertarvaloracionemodal',
	templateUrl: './insertarvaloracionemodal.component.html',
	styleUrls: ['./insertarvaloracionemodal.component.scss']
})

export class InsertarValoracioneModalComponent implements OnInit {
	breakpoint: number;
	ratio = '4:1';
	public dataAsignaciones:any;
	public dataRepuestoservicios:any;
	public formInsertarValoracione: FormGroup;

	constructor(private fb: FormBuilder,
		public dialogRef: MatDialogRef <InsertarValoracioneModalComponent>,
		private servicioValoracione:ValoracionesServices,
		private servicioAsignacione:AsignacionesServices,
		private servicioRepuestoservicio:RepuestoserviciosServices,
		private mensajes:NotificationServices,) { }

	ngOnInit() {
	
		this.breakpoint = (window.innerWidth <= 800) ? 1 : 2;
		this.ratio=(window.innerWidth <= 800) ? '4:1.6':'4:1';
		if(this.breakpoint!=1){
			this.dialogRef.updateSize("50%", "60%");
		}else{
			this.dialogRef.updateSize("100%", "80%");
		}
	
		this.servicioAsignacione.obtenerDatosAsignaciones().subscribe((data:any)=>{
			this.dataAsignaciones=data.asignaciones;
		});
		this.servicioRepuestoservicio.obtenerDatosRepuestoservicios().subscribe((data:any)=>{
			this.dataRepuestoservicios=data.repuestoservicios;
		});
	
		this.formInsertarValoracione = this.fb.group({
			estado:[1,null],
			asignacione_id:[null,Validators.compose([Validators.required,CustomValidators.number])],
			repuestoservicio_id:[null,Validators.compose([Validators.required,CustomValidators.number])],
		});
	}


	saveValoracione(){
		let valoracioneDataModel:Valoraciones=this.formInsertarValoracione.value;
		this.servicioValoracione.guardarValoraciones(valoracioneDataModel).subscribe((data:any)=>{
			if(data.estado){
				this.mensajes.setNotification(data).then((datas)=>{
					if(datas){
						this.dialogRef.close(1);
					}
				});
			}else{
				this.mensajes.setNotification(data);
			}
		});
	}


	onResize(event){
		this.breakpoint = (event.target.innerWidth <= 800) ? 1 : 2;
		this.ratio=(event.target.innerWidth <= 800) ? '4:1.6':'4:1';
		if(this.breakpoint!=1){
			this.dialogRef.updateSize("50%", "60%");
		}else{
			this.dialogRef.updateSize("100%", "80%");
		}
	}

	cerrarModal(){
		this.dialogRef.close(2);
	}
}

MatDialogRef.prototype.updateSize = function (width, height) {
	if (width === void 0) { width = 'auto'; }
	if (height === void 0) { height = 'auto'; }
	this._getPositionStrategy().width(width).height(height);
	this._overlayRef.updatePosition();
	return this;
};